module.exports = __webpack_public_path__ + "img/pig9.0b85cb24.png";